const id_trans_common = {
    dist_point: "titik distribusi",
    search_ref: "cari referensi",
    stock_remainning: "sisa stok",
    req_id: "ID permintaan",
    trans_id: "ID transaksi",

    qty_po: "kuantitas PO",
    qty_so: "kuantitas SO",
    btn_cost: "tambah biaya",
    btn_discount: "tambah potongan",
    cost_added: "tambahan biaya",
    cost_discount: "potongan biaya",

    pay: 'bayar',
    paid: 'dibayar',
    // pay_deposit: 'bayar titipan',

    remaining: "sisa",
    inv_amount: "total tagihan",

    rfq: "permintaan penawaran",
    rfq_add: "buat permintaan penawaran",

    label: {
        ppn_used: "Menggunakan PPN",

        dp: "down payment (DP)",
        dp_nominal: "nominal down payment",
        dp_pay: "bayar down payment",

        inv_add: "tambah invoice",
        inv_del: "hapus invoice",
    },
}

export default id_trans_common;